module.exports = __webpack_public_path__ + "img/safety.e34f7d93.png";